<style scoped>
    @import url("../../../styles/smartControl/histIaIrrig.scss");
</style>

<template>
    <div class="box_histIaIrrig">

        <div class="macro_el">
            <div class="tit ml-2">Histórico de decisão</div>

            <div class="mb-2 mt-2">
                <v-chip color="#F5DDC0">{{ msgChipHist }}</v-chip>
            </div>

            <div class="backPainelExib" v-if="flagExibHist">

                <div class="painelExib mt-1 mb-1" v-for="(el,i) in liHistExib" :key="i">

                    <div class="card_el_info">
                        <span>Data:</span>
                        <span class="ml-2 el_info">{{ el.data }}</span>
                    </div>

                    <div class="card_el_info">
                        <span>minutos:</span>
                        <span class="ml-2 el_info">{{ el.manejo.qnt_luz_minutos }}</span>
                    </div>

                    <div class="card_el_info">
                        <span>Justificativa:</span>
                        <span class="ml-2 el_info">{{ el.resposta }}</span>
                    </div>
                </div>
            </div>

            <div class="backBtnExpand mt-2" @click="expandHist()" v-if="flagExibBtnExpand">
                <v-btn 
                height="40px"
                width="40px"
                density="comfortable"
                icon
                :style="{'color':'green'}"
                >
                    <v-icon class="" size="16">mdi-plus</v-icon>
                </v-btn>
            </div>

        </div>

    </div>
</template>

<script>
export default {

    props:['liResIA'],

    data() {
        return {

            //
            liHist:[],
            liHistRecent:[],
            liHistExib:[],
            msgChipHist:'Informações recentes',
            flagExibHist:false,
            flagExibBtnExpand:false,
        }
    },

    methods:{

        expandHist() {
            //console.log('start')
            // -- trocar frase informativa.
            this.flagExibHist = false
            this.msgChipHist = `${this.liHist.length} informações`
            this.liHistExib = this.liHist
            this.flagExibBtnExpand = false
            this.flagExibHist = true
            //console.log('end')
        },

        initHist() {

            // rcb props
            this.liHist = this.liResIA

            if (this.liHist.length < 1) {
                this.msgChipHist = `Nenhuma informação disponível`
                this.flagExibHist = false
                return
            }

            if (this.liHist.length > 2) {
                let c = 0
                while (c < 3) {
                    //console.log(this.liHist[c])
                    this.liHistRecent.push(this.liHist[c])
                    c++
                }
                this.liHistExib = this.liHistRecent
                this.flagExibBtnExpand = true // apenas se houver expansão
            }
            else {
                this.liHistExib = this.liHist
            }
            //console.log(this.liHistExib)

            //flagLoading = false // -- close loading
            //this.$emit('boolFromChild', flagLoading) // father control

            this.flagExibHist = true
        },
    },

    async created() {
        //window.scrollTo(0,0)
        this.initHist()
    }
}
</script>